import {
  LayoutNode,
  LayoutNodeActionType,
  LayoutNodeType,
} from "@towersystems/roam-common/lib/generated-types";
import { useMemo, useState } from "react";
import { ScrollView } from "react-native";
import { GridList, Spacings } from "react-native-ui-lib";
import {
  LayoutDimensions,
  deriveLayoutDimensions,
  makePageItem,
} from "../../../../../../utilities/layout";
import { DefaultActionItemRenderer } from "../../renderers";

export const DefaultQuickKeyList = () => {
  const [layoutDimensions, setLayoutDimensions] = useState<LayoutDimensions>();

  const defaultPageItems = useMemo(
    () =>
      DEFAULT_ACTION_LAYOUT_NODES.map((partialNode, i) =>
        makePageItem({
          id: `${DEFAULT_ID_PREFIX}-${i}`,
          type: LayoutNodeType.ACTION,
          position: i,
          ...partialNode,
        } as LayoutNode)
      ),
    []
  );

  const defaultGridMarkup = layoutDimensions ? (
    <GridList
      nestedScrollEnabled={true}
      contentContainerStyle={{ width: "100%" }}
      data={defaultPageItems}
      numColumns={layoutDimensions.columns}
      renderItem={({ item }) => <DefaultActionItemRenderer {...{ item }} />}
      containerWidth={layoutDimensions.width}
    ></GridList>
  ) : undefined;

  return (
    <ScrollView
      nestedScrollEnabled={true}
      style={{ marginTop: Spacings.s7 }}
      onLayout={(event) => {
        const { width } = event.nativeEvent.layout;
        setLayoutDimensions(deriveLayoutDimensions(width));
      }}
    >
      {defaultGridMarkup}
    </ScrollView>
  );
};

const excludedActions: string[] = [];

const isDefaultAction = (action: LayoutNodeActionType) =>
  !excludedActions.includes(action);

const DEFAULT_ACTION_LAYOUT_NODES: Partial<LayoutNode>[] = Object.values(
  LayoutNodeActionType
)
  .filter(isDefaultAction)
  .filter(
    (i) =>
      !["CUSTOMER_ACCOUNT_PAYMENT", "SALES_HISTORY", "CUSTOM_URL"].includes(
        i as string
      )
  )
  .map((action) => ({ action }));

const DEFAULT_ID_PREFIX = "default-quick-key";
